import React from 'react';
interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  tone?: 'light' | 'dark';
  align?: 'left' | 'center';
  as?: 'h2' | 'h3';
  id?: string;
}
export function SectionHeading({
  title,
  subtitle,
  tone = 'light',
  align = 'center',
  as: Tag = 'h2',
  id
}: SectionHeadingProps) {
  const dark = tone === 'dark';
  return <div className={['max-w-3xl', align === 'center' ? 'mx-auto text-center' : ''].join(' ')} data-id="element-426" data-mp="rxhu9tzb9j8u">
      <Tag id={id} className={['font-display font-bold tracking-tight', 'text-3xl leading-tight md:text-[2.6rem] md:leading-[1.15]', dark ? 'text-white' : 'text-navy'].join(' ')} data-id="element-427" data-mp="i7yb0n7orndg">
        {title}
      </Tag>
      {subtitle && <p className={['mt-4 text-base md:text-lg', dark ? 'text-white/75' : 'text-ink-muted'].join(' ')} data-id="element-428" data-mp="4870iwgdop47">
          {subtitle}
        </p>}
      <span className={['mt-6 block h-1 w-16 rounded-full', align === 'center' ? 'mx-auto' : '', dark ? 'bg-cta-light' : 'bg-cta'].join(' ')} aria-hidden="true" data-id="element-429" data-mp="3vfsz4ao8q1e7" />
    </div>;
}